import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-social-facebook",
  "use": "icon-social-facebook-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-social-facebook\"><path d=\"M297.5 173v-49.4c0-22.3 4.9-33.6 39.6-33.6h43.4V7H308c-88.8 0-118.1 40.7-118.1 110.6V173h-58.4v83h58.4v249h107.6V256h73.1l9.9-83h-83z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol